import React from 'react';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import {QCJobItem} from '../../QCWorkflow/QCManager/QCManagerTypes';

const getStatusIcon = (item: QCJobItem) => {
    const {status} = item;
    
    switch(status) {
    case 'In QC':
        return (
            <div>
                <InfoIcon className="inQc-icon" />
                {status}
            </div>
        );
    case 'QC Passed':
        return (
            <div>
                <CheckCircleIcon className="qcPassed-icon" />
                {status}
            </div>
        );
    case 'QC Failed':
        return (
            <div>
                <WarningIcon className="qcFailed-icon" />
                {status}
            </div>
        );
    default:
        return <div>{status}</div>;
    }
};

export default getStatusIcon;
